import React from "react";
import { FormSection } from "redux-form";

import  {
	Card,
	ProgressIndicator
} from "rhombus-react";

import { SOCIAL_AD_TYPES } from "utils/constants";
import { useErrorBanner } from "social/utils";

import GoogleDemandGenCardContent from "widgets/social2/carousel/GoogleDemandGenCardContent";

import GoogleDemandGenCarouselCardForm, { GOOGLE_DEMAND_GEN_CAROUSEL_CARD_FIELDS } from "widgets/social2/carousel/GoogleDemandGenCarouselCardForm";
import GoogleDemandGenMainContent from "../carousel/GoogleDemandGenMainContent";

export default function GoogleDemandGenCarousel(props){
	const {
		libraryId,
		navigationActions,
		isViewOnly,
		showPristineErrors,
	} = props;
	const adType = SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_CAROUSEL;

	const showPristine = showPristineErrors || ["cardCount"]; // Always show at least the card count error

	const errorDisplay = useErrorBanner(adType, showPristine, GOOGLE_DEMAND_GEN_CAROUSEL_CARD_FIELDS);

	return (
		<FormSection name={adType}>
			<div className="carousel-modal-content progress-container letterboxed">
				{errorDisplay}
				<ProgressIndicator isLoading={false} />
				<Card
					className="carousel-main-content"
					header="Main Content"
					isCollapsable
					isVisible
				>
					<GoogleDemandGenMainContent
						libraryId={libraryId}
						adType={adType}
						isViewOnly={isViewOnly}
						showPristineErrors={showPristineErrors}
						navigationActions={navigationActions}
					/>
				</Card>
				<GoogleDemandGenCardContent
					libraryId={libraryId}
					adType={adType}
					isViewOnly={isViewOnly}
					showPristineErrors={showPristineErrors}
					navigationActions={navigationActions}
					CardForm={GoogleDemandGenCarouselCardForm}
				/>
			</div>
		</FormSection>
	);
}

GoogleDemandGenCarousel.displayName = "GoogleDemandGenCarousel";
